import { useEffect, useState } from 'react'

/**
 * Returns the DOM node FloraProvider renders around its subtree, so Modal/Drawer
 * components can use it as their Portal `container` and inherit Flora theme tokens
 * instead of falling back to `document.body` (which sits outside FloraProvider's
 * themed scope and loses the tokens).
 * @returns {HTMLElement|null}
 */
export function useFloraPortalContainer() {
  const [container, setContainer] = useState(null)

  useEffect(() => {
    setContainer(document.querySelector('[data-flora="provider"]'))
  }, [])

  return container
}
